module.exports = __webpack_public_path__ + "static/heroImg-3625330661c4c4442e87db4990c8f1d7.png";